import ToolTip from 'Components/ToolTip'
import React from 'react'
import { Roles, Order } from 'shared/constants'
import { hasRole } from 'utils/auth/authUtils'

interface VesselTableHeadComponentType {
    reportStatus: string,
    tab?: number,
    setOrder?: any,
    order?: string
}

const VesselTableHeadComponent = ({
    reportStatus,
    tab,
    setOrder,
    order
}: VesselTableHeadComponentType) => {
    const [hoverId, setHoverId] = React.useState<string | null>(null);

    const toggleOrder = () => {
        setOrder(order === Order.ASC ? Order.DESC : Order.ASC);
        setHoverId(null);
    };

    return (
        <thead className="table-light">
            <tr>
                <th className='p-2 align-middle sr-no-width'>#</th>

                {reportStatus === 'ongoing' ? (
                    <>
                        <th className='p-2 align-middle' style={{ width: '15%' }}>Vessel report name</th>
                        <th className='p-2 align-middle text-center' style={{ width: '12%' }}>Report type</th>
                    </>
                ) : (
                    <th className='p-2 align-middle' style={{ width: '15%' }}>Vessel report name (Report type)</th>
                )}

                <th className='p-2 align-middle text-center' style={{ width: '15%' }}>
                    Reporting time (Local) {''}
                    {tab === 2 && (
                        <i
                            id="order-toggle-icon"
                            className={`bx ${order === Order.ASC ? "bx-sort-up" : "bx-sort-down"
                                } ms-2 align-middle pointer color-assign-user icon_s18`}
                            onClick={toggleOrder}
                            onMouseEnter={() => setHoverId("order-toggle-icon")}
                            onMouseLeave={() => setHoverId(null)}
                        />
                    )}
                </th>

                <th
                    className='p-2 align-middle text-center'
                    style={{ width: '20%', cursor: tab === 2 ? "pointer" : "default" }}
                    colSpan={
                        hasRole(Roles.ES_ADMIN)
                            || hasRole(Roles.ADMIN) ? reportStatus === 'ongoing' ? 7 : 6
                            : hasRole(Roles.MASTER)
                                ? 5
                                : hasRole(Roles.CHIEFENGINEER)
                                    ? 3
                                    : 0
                    }
                >
                    Actions{" "}
                </th>
            </tr>

            {/* Tooltip */}
            {hoverId && (
                <ToolTip
                    target="order-toggle-icon"
                    message={order === Order.ASC ? "Sort descending" : "Sort ascending"}
                    isOpen
                />
            )}
        </thead>
    );
}

export default VesselTableHeadComponent;
